@if (hasMismatch()) {
  <kendo-popover
    #mismatchPopover
    [position]="'left'"
    [callout]="false"
    [width]="250">
    <ng-template kendoPopoverBodyTemplate>
      <div class="popup-left">
        <div class="d-flex flex-column">
          <div class="grid template-cols-6 gap-8">
            <div class="g-col-6">
              <div class="ps-16 pe-16 d-flex justify-content-between">
                <div class="fc-primary-300 fw-700">{{ label() | translate | capitalize }}</div>
                <div class="fw-600">{{ value()! | kendoNumber: decimalFormat }}</div>
              </div>
            </div>
            <div class="g-col-6">
              <div class="ps-16 pe-16 d-flex justify-content-between">
                <div class="fc-primary-300 fw-700">{{ calculatedLabel() | translate | capitalize }}</div>
                <div class="fw-600">{{ calculatedValue()! | kendoNumber: decimalFormat }}</div>
              </div>
            </div>
            <div class="g-col-6">
              <div class="ps-16 pe-16 d-flex justify-content-between">
                <div class="fw-700 fc-primary-300">{{ 'DIFFERENCE' | translate | capitalize }}</div>
                <div class="fw-600">{{ difference()! | kendoNumber: decimalFormat }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-popover>
  <span kendoPopoverAnchor [showOn]="'hover'" [popover]="mismatchPopover">
    <span class="fc-accents-yellow-500 fs-16 pe-8"><i class="rc-icon-alert-triangle"></i></span>
  </span>
}
